var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import getLimits, { hitLimits } from "@irati/checkout/utils/deal/getLimits";
import withBasket from "@irati/checkout/utils/basket/withBasket";
import { MaxAmountReached, MaxItemsReached, MaxProductsReached, UnderMinAmount } from "./Limits";
import ProductTypes from "../../constants/productTypes";
var LimitWrapper = /** @class */ (function (_super) {
    __extends(LimitWrapper, _super);
    function LimitWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            reachedMinPrice: false,
            reachedMaxPrice: false,
            reachedMaxProducts: false,
            reachedMaxItems: false,
            minPrice: 0,
            maxPrice: 0,
            maxItems: 0,
            currency: "GBP"
        };
        return _this;
    }
    LimitWrapper.getDerivedStateFromProps = function (props) {
        var currency = props.basket.breakdown.total.currency;
        var _a = hitLimits(props.deal), reachedMinPrice = _a.reachedMinPrice, reachedMaxPrice = _a.reachedMaxPrice, reachedMaxProducts = _a.reachedMaxProducts, reachedMaxItems = _a.reachedMaxItems;
        var _b = getLimits(props.deal), minPrice = _b.minPrice, maxPrice = _b.maxPrice, maxItems = _b.numItems;
        return { currency: currency, minPrice: minPrice, maxPrice: maxPrice, maxItems: maxItems, reachedMinPrice: reachedMinPrice, reachedMaxPrice: reachedMaxPrice, reachedMaxProducts: reachedMaxProducts, reachedMaxItems: reachedMaxItems };
    };
    LimitWrapper.prototype.render = function () {
        var _a = this.state, reachedMinPrice = _a.reachedMinPrice, reachedMaxPrice = _a.reachedMaxPrice, reachedMaxProducts = _a.reachedMaxProducts, reachedMaxItems = _a.reachedMaxItems, minPrice = _a.minPrice, maxPrice = _a.maxPrice, maxItems = _a.maxItems, currency = _a.currency;
        var productType = this.props.productType;
        var isCinema = productType === ProductTypes.CINEMA;
        var isSingleProduct = productType === ProductTypes.SINGLE_PRODUCT;
        var showWarning = !isCinema && !isSingleProduct;
        return (React.createElement("div", null,
            !isSingleProduct && reachedMaxItems && React.createElement(MaxItemsReached, { maxItems: maxItems }),
            showWarning && reachedMaxPrice && React.createElement(MaxAmountReached, { maxPrice: maxPrice, currency: currency }),
            showWarning && !reachedMinPrice && React.createElement(UnderMinAmount, { minPrice: minPrice, currency: currency }),
            showWarning && reachedMaxProducts && React.createElement(MaxProductsReached, null),
            this.props.children));
    };
    return LimitWrapper;
}(Component));
export default withBasket(LimitWrapper);
